import { ApplicationForm } from "@prisma/client";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axios from "axios";

interface FormCreateParams {
  applicationId: string;
  namespace?: string;
  parentId?: string;
}

export function useApplicationFormCreateMutation(
  options: UseMutationOptions<ApplicationForm, unknown, FormCreateParams> = {}
) {
  return useMutation(
    async ({ applicationId, namespace, parentId }) =>
      axios
        .post(`/api/application/${applicationId}/form`, {
          namespace,
          parentId,
        })
        .then((response) => response.data),
    options
  );
}
